<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { typeIcon } from '../bookingTypes';
import BookingDetailsSection from './BookingDetailsSection.vue';

const props = defineProps({
  details: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const components = computed(() => props.details.components || []);

const labelFor = type =>
  t(`CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.TYPE_OPTIONS.${type.toUpperCase()}`);
</script>

<template>
  <div class="flex flex-col gap-4">
    <div
      v-for="(component, index) in components"
      :key="index"
      class="flex flex-col gap-2"
    >
      <p
        class="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-n-slate-10"
      >
        <span :class="typeIcon(component.type)" class="size-3.5" />
        {{ labelFor(component.type) }}
      </p>
      <BookingDetailsSection
        :booking-type="component.type"
        :details="component"
      />
    </div>
    <div v-if="details.notes" class="space-y-2">
      <p class="text-xs font-medium text-n-slate-11">
        {{ t('CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.NOTES') }}
      </p>
      <p class="text-sm text-n-slate-12">{{ details.notes }}</p>
    </div>
  </div>
</template>
